import { Box, Container, Grid, TextField, Typography } from '@mui/material'
import { BrokenImageOutlined } from '@mui/icons-material'
import DrawerLongWidth from 'components/drawerLongWidth/detail'
import Loading from 'components/loading/loading'
import type { DetailStatePropsLongWidth } from 'modules/types'
import { useGetReferralDetailQuery } from 'store/referral'
import GLOBAL from "modules/global"
import DetailStyle from './style'

const Detail = ({ open, id, onClose }: DetailStatePropsLongWidth & { id: number }) => {
  if (!open) return <DrawerLongWidth open={open} onClose={onClose} />

  const { data, isLoading, isFetching } = useGetReferralDetailQuery(id)

  const memberId = (data && data.memberCode) || '-'
  const fullName = (data && data.fullName) || '-'
  const vin = (data && data.vin) || '-'
  const relationshipType = (data && data.relationshipType) || '-'
  const relationshipDetail = (data && data.relationshipDetail) || '-'
  const referredName = (data && data.referredName) || '-'
  const referredPhoneNumber = (data && data.referredPhoneNumber) || '-'
  const provinceCode = (data && data.provinceCode) || '-'
  const preferredDealerCode = (data && data.preferredDealerCode) || '-'
  const formSubmissionDate = data?.createdAt ? GLOBAL.formatDateWithTime(data.createdAt) : '-'
  const identityCardPath = data && data.identityCardPath
  const familyCardPath = data && data.familyCardPath

  const leftFields = [
    { label: 'Member ID', value: memberId },
    { label: 'Full Name', value: fullName },
    { label: 'VIN', value: vin },
    { label: 'Relationship', value: relationshipType },
    { label: 'Other Relationship', value: relationshipDetail },
    { label: 'Name of the Referred Person', value: referredName },
    { label: 'Referred Phone Number', value: referredPhoneNumber }
  ]

  const rightFields = [
    { label: 'Province of the Referred Person', value: provinceCode },
    { label: 'Preferred Dealer', value: preferredDealerCode },
    { label: 'Form Submission Date', value: formSubmissionDate }
  ]

  const renderImageSection = (label: string, imagePath: string | null | undefined) => (
    <Box sx={{ mb: 2 }}>
      <Typography variant='body1' sx={{ fontWeight: 600, mb: 1 }}>
        {label}
      </Typography>
      {imagePath ? (
        <Box {...DetailStyle.ImageBox}>
          <img
            src={imagePath}
            alt={label}
            style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
          />
        </Box>
      ) : (
        <Box {...DetailStyle.ImagePlaceholder}>
          <BrokenImageOutlined sx={{ fontSize: 40, color: '#ccc' }} />
          <Typography variant='body2' color='textSecondary'>
            Select a Photo
          </Typography>
        </Box>
      )}
    </Box>
  )

  return (
    <DrawerLongWidth open={open} title='Referral Program Detail' onClose={onClose} maxWidth='lg'>
      <Container {...DetailStyle.Container}>
        {(isLoading || isFetching) && !data && <Loading />}
        {data && (
          <Grid container spacing={2}>
            <Grid item xs={6}>
              {leftFields.map((field, index) => (
                <TextField
                  key={index}
                  variant='outlined'
                  label={field.label}
                  value={field.value}
                  inputProps={{ readOnly: true }}
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  sx={{ mb: 2 }}
                />
              ))}
            </Grid>
            <Grid item xs={6}>
              {rightFields.map((field, index) => (
                <TextField
                  key={index}
                  variant='outlined'
                  label={field.label}
                  value={field.value}
                  inputProps={{ readOnly: true }}
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  sx={{ mb: 2 }}
                />
              ))}
              {renderImageSection('Identity Card Photo (KTP/KITAS)', identityCardPath)}
              {renderImageSection('Family Card Attachment', familyCardPath)}
            </Grid>
          </Grid>
        )}
      </Container>
    </DrawerLongWidth>
  )
}

export default Detail
